<div class="text-muted-warm font-xs lh-1">
  {{ questionTitle }}
</div>

<div class="mt-1 font-md description-lh order-description">
  {{ answer }}
</div>
